<template>
    <div class="headlogout" @click="logout()">
        <i class="icon beerFamily beer-icon-thirddengchu"></i>
    </div>
</template>
<script>
export default {
  data () {
    return {

    }
  },
  methods: {
    logout () {
      this.$store.dispatch('LogOut').then(() => {
        location.reload()
      })
    }
  }
}
</script>
<style lang="less" scoped>
.headlogout{
    height: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 0 10px;
    width: 50px;
    &:hover{
        background: #ececec
    }
}
</style>



// WEBPACK FOOTER //
// src/components/utils/Headlogout.vue